<template>
  <div>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && itemAprovacao">
      <px-aprovacao-compra-detalhes-produto-dados-basicos :aprovacao-id="aprovacaoId"
                                                          :fornecedor-id="fornecedorId"
                                                          :item-aprovacao="itemAprovacao"
                                                          @update="onUpdate"/>
      <px-aprovacao-detalhes-produto-compras v-if="itemAprovacao.produto"
                                             :item-aprovacao="itemAprovacao"/>
      <px-aprovacao-detalhes-produto-cotacoes v-if="itemAprovacao.produto"
                                              :item-aprovacao="itemAprovacao"/>
      <px-aprovacao-detalhes-produto-estoque v-if="itemAprovacao.produto"
                                             :item-aprovacao="itemAprovacao"/>
      <px-aprovacao-produto-aprovadores :item-aprovacao="itemAprovacao"/>
    </div>
  </div>
</template>

<script>
import AprovacaoCompraService from '@/modules/aprovacao-compra/aprovacao-compra-service';
import AprovacaoCompraDetalhesProdutoDadosBasicos
  from '@/modules/aprovacao-compra/detalhes-produtos/AprovacaoCompraDetalhesProdutoDadosBasicos.vue';

export default {
  props: {
    aprovacaoIdProp: {
      type: [String, Number],
    },
    fornecedorId: {
      type: [String, Number],
    },
    itemIdProp: {
      type: [String, Number],
    },
  },
  data() {
    return {
      loading: false,
      aprovacaoId: null,
      itemId: null,
      itemAprovacao: null,
    };
  },
  methods: {
    getAprovacaoProduto() {
      this.loading = true;
      AprovacaoCompraService.getProduto(this.aprovacaoId, this.itemId)
        .then(({ data }) => {
          this.itemAprovacao = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onUpdate(aprovacaoAtualizada) {
      this.$emit('update', aprovacaoAtualizada);
      this.getAprovacaoProduto();
    },
  },
  created() {
    this.aprovacaoId = this.aprovacaoIdProp || this.$route.params.id;
    this.itemId = this.itemIdProp;
    this.getAprovacaoProduto();
  },
  components: {
    pxAprovacaoCompraDetalhesProdutoDadosBasicos: AprovacaoCompraDetalhesProdutoDadosBasicos,
  },
};
</script>
